import { useApi } from "./useApi";

import { Events, dispatch } from "../redux/dispatch";

export const usePool = () => {
  const { client } = useApi();

  const getMainPool = async () => {
    const pool = await client.get("/v1/pools");
    if (pool) {
      const matches = pool.matches.sort(
        (a, b) => new Date(a.time).getTime() - new Date(b.time).getTime(),
      );
      return dispatch(Events.SET_MAIN_POOL, {
        ...pool,
        matches,
      });
    }
    dispatch(Events.SET_MAIN_POOL, null);
  };

  const createMainPool = async (matches, startAt) =>
    await client.post("/v1/pools", { matches, startAt });

  const updateMainPool = async (matches) => {
    await client.patch("/v1/pools", matches);
    await getMainPool();
  };

  const startMainPool = async () => {
    await client.patch("/v1/pools/start");
    await getMainPool();
  };

  const createUserPool = async (matches) => {
    await client.post("/v1/users/pool", matches);
  };

  const resetPool = async () => {
    await client.delete("/v1/pools");
  };

  return {
    createMainPool,
    createUserPool,
    getMainPool,
    resetPool,
    startMainPool,
    updateMainPool,
  };
};
